/* Model */
class IPRangeProfileModel extends App.Models.BaseModel {
    modelUrl = 'IPRangeProfile';
}

App.Models.IPRangeProfile = IPRangeProfileModel;

/* Collection */
class IPRangeProfileCollection extends App.Collections.BaseCollection {
    url = 'IPRangeProfile';
    model = App.Models.IPRangeProfile;
}

App.Collections.IPRangeProfiles = IPRangeProfileCollection;

/* Router */
class IPRangeProfileRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'IPRangeProfile';
        const model = App.Models.IPRangeProfile;
        const collectionClass = App.Collections.IPRangeProfiles;

        super(entityName, model, collectionClass);
    }

    afterCreateForm = function (entity, formData, crudStage) {
        if (crudStage === 'new') {
            this.populateFields();
        }
    }

    checkStatusIPRangeProfile = () => {
        const listIpRange = $(".span_container_ip");

        $(".buttonAdd").hide();
        $(".buttonRemove").show();
        if (listIpRange.length === 1) {
            $(".buttonRemove").hide();
            $(".buttonAdd").show();
            return;
        }

        const divLastIpRange = listIpRange[listIpRange.length - 1];
        divLastIpRange.children[divLastIpRange.children.length - 1].children[0].style.display = 'block';
        divLastIpRange.children[divLastIpRange.children.length - 1].children[1].style.display = 'block';
    }

    checkIndex = () => {
        Monet.Session.IPRangeProfile = Monet.Session.IPRangeProfile || {};
        if (typeof Monet.Session.IPRangeProfile.index === "undefined") {
            Monet.Session.IPRangeProfile.idsToDelete = [];
        }
    }

    populateFields = (data) => {
        const monetSectionSelector = '#IPRangeProfile .MonetUIFormSection';
        const formIpRangeProfile = document.querySelector(monetSectionSelector + '[key="pls_edit_range_ip_range_profile"]') ||
            document.querySelector(monetSectionSelector + '[key="pls_new_range_ip_range_profile"]');

        this.checkIndex();
        const field = new Greenmile.IPRangeProfile.IPRangeListFields();
        field.setData(data);

        App.Forms.IPRangeProfile.form.fields.ipRanges = field;
        formIpRangeProfile.appendChild(field.render());

        this.addListeners();
        this.checkStatusIPRangeProfile();
    }

    addListeners = () => {
        $(".buttonAdd").off("click");
        $(".buttonAdd").on("click", () => {
            App.Forms.IPRangeProfile.form.fields.ipRanges.createElement();
            this.checkStatusIPRangeProfile();
            this.addListeners();
        });

        $(".buttonRemove").off("click");
        $(".buttonRemove").on("click", (e) => {
            var containerIPRange = e.target.parentNode.parentNode;
            App.Forms.IPRangeProfile.form.fields.ipRanges.removeItem(e.target.parentNode.parentNode.children[0].id);
            const parentBtn = containerIPRange.parentNode;
            this.addToBatchDelete(e);
            parentBtn.removeChild(containerIPRange);

            this.checkStatusIPRangeProfile();
        });

        //validar caracteres
        this.validateCharacter();
    }

    addToBatchDelete = (e) => {
        if (e.target.parentNode.parentNode.id !== '') {
            const idEdit = parseInt(e.target.parentNode.parentNode.id, 10);
            Monet.Session.IPRangeProfile.idsToDelete.push(idEdit);
        }
    }

    validateCharacter = () => {
        var validaEvento = (e) => {
            const validateIp = $(e.target).val(),
                charIP = validateIp.match(/[^0-9.]/g),
                hasLettersIp = ( validateIp.match(/[^0-9.]/g) !== null ) ? true : false;

            if (hasLettersIp) {
                for (let i = 0; i < charIP.length; i++) {
                    const x = $(e.target).val().replace(charIP[i], "");
                    $(e.target).val(x);
                }
            }
        };

        $(".ipv4Start").on("keyup", function (e) {
            validaEvento(e);
        });

        $(".ipv4End").on("keyup", function (e) {
            validaEvento(e);
        });
    }

    afterPopulateForm = () => {
        let error, ajax = null;
        const url = 'IPRange/filter?criteria={"filters":["*"]}';

        try {
            if (this.editModelId) {
                ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.method = "post";
                ajax.data = { 'rangeProfile': { 'id': this.editModelId } };
                ajax.success = (data) => {
                    if (data && !this.permissionDenied) {
                        this.populateFields(data);
                        this.checkStatusIPRangeProfile();
                    }
                };
                ajax.send();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on control screen");
            error.console();
        }
    }

    beforeCreate = () => {
        this.checkDeleteIpRange();
    }

    onValidate = () => {
        const ipv4start = [];
        const ipv4end = [];

        $.each($(".ipv4Start"), function (index, value) {
            ipv4start.push(value.value);
        });

        $.each($(".ipv4End"), function (index, value) {
            ipv4end.push(value.value);
        });

        var addErrorMessage = (name) => {

            this.allow_submit.errorMessages.push(
                Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey(name) + ' ' + Monet.I18n.getResourcesByKey("error.isrequired"))
            );
            this.allow_submit.status = false;
        };

        for (let i = 0; i < ipv4start.length; i++) {
            if (ipv4start[i] === '') {
                addErrorMessage('ipRangeProfile.ipv4Start');
                break;
            }
        }

        for (let i = 0, length = ipv4end.length; i < length; i++) {
            if (ipv4end[i] === '') {
                addErrorMessage('ipRangeProfile.ipv4End');
                break;
            }
        }

        this.validateRangeIP(ipv4start, ipv4end);
    }

    checkDeleteIpRange = () => {
        if (Monet.Session.IPRangeProfile && Monet.Session.IPRangeProfile.idsToDelete.length !== 0) {
            this.batchDeleteIpRange(Monet.Session.IPRangeProfile.idsToDelete);
        }

        if (Monet.Session.IPRangeProfile) {
            Monet.Session.IPRangeProfile.idsToDelete = [];
        }
    }


    batchDeleteIpRange = (idsToDelete) => {
        let error = null;
        let ajax  = null;
        const url   = "IPRange/BatchDelete";

        try {
            if (typeof idsToDelete !== "undefined" && idsToDelete.length > 0) {
                ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.method = "post";
                ajax.data = idsToDelete;
                ajax.error = (xhr) => {
                    if (xhr.responseText !== "") {
                        const response = JSON.parse(xhr.responseText);
                        this.showErrorExceptionOnPopupForm(response);
                    }
                };
                ajax.send();
            } else {
                error = new Monet.Exception.ReturnError(this, "No item to delete");
                error.console();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on batch delete");
            error.console();
        }
    }

    validateRangeIP = (ipv4start, ipv4end) => {
        const availableIP = this.splitIP(ipv4start, ipv4end);
        const sizeIP = ( typeof availableIP[0] !== "undefined" ) ? availableIP[0].start.length : 0;

        $.each($(".textIPRange"), (index, value) => {
            const notIpValid = !this.checkIPISValid(value.value);
            if (notIpValid && value.value !== '' && this.allow_submit) {
                this.allow_submit.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject("error.formatIpRange"));
                this.allow_submit.status = false;
            }

            if (notIpValid) {
                $(value).css("background-color", "#ffe5e5");
                $(value).css("border-color", "#b94a48");
            } else {
                $(value).css("background-color", "");
                $(value).css("border-color", "");
            }
        });

        for (let i = 0; i < sizeIP; i++) {
            const start = availableIP[0].start[i];
            const end = availableIP[0].end[i];
            const containerDiv = $(".span_container_ip");
            let divToChangeStyle;
            if (parseInt(start, 10) > parseInt(end, 10)) {
                divToChangeStyle = containerDiv[i];

                //setando a cor
                divToChangeStyle.getElementsByTagName('input')[0].style.backgroundColor = '#ffe5e5';
                divToChangeStyle.getElementsByTagName('input')[0].style.borderColor = '#b94a48';
                divToChangeStyle.getElementsByTagName('input')[1].style.backgroundColor = '#ffe5e5';
                divToChangeStyle.getElementsByTagName('input')[1].style.borderColor = '#b94a48';

                if (this.allow_submit) {
                    this.allow_submit.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject("IPRangeProfile.error.initialIsGreater"));
                    this.allow_submit.status = false;
                }
            } else {
                divToChangeStyle = containerDiv[i];
                if (this.checkIPISValid(ipv4start[i]) &&
                    this.checkIPISValid(ipv4end[i])) {
                    //setando a cor
                    divToChangeStyle.getElementsByTagName('input')[0].style.backgroundColor = '';
                    divToChangeStyle.getElementsByTagName('input')[0].style.borderColor = '';
                    divToChangeStyle.getElementsByTagName('input')[1].style.backgroundColor = '';
                    divToChangeStyle.getElementsByTagName('input')[1].style.borderColor = '';
                }
            }
        }
    }


    splitIP = (ipStart, ipEnd) => {
        const splitIpStart = [];
        const splitIpEnd = [];
        const finalIp = [];
        let isValidIPv4 = true;
        let ipSplit;

        //IP START
        for (let i = 0; i < ipStart.length; i++) {
            ipSplit = ipStart[i].split(".");
            isValidIPv4 = this.isValidIPv4(ipSplit);

            if (isValidIPv4) {
                splitIpStart.push(this.calculateMinMaxIP(ipSplit));
            }
        }

        //IP END
        for (let j = 0; j < ipEnd.length; j++) {
            ipSplit = ipEnd[j].split(".");
            isValidIPv4 = this.isValidIPv4(ipSplit);

            if (isValidIPv4) {
                splitIpEnd.push(this.calculateMinMaxIP(ipSplit));
            }
        }

        finalIp.push({ "start": splitIpStart, "end": splitIpEnd });
        return finalIp;
    }

    isValidIPv4 = (splitIp) => {
        var isIP = (splitIp.length === 4) ? true : false;
        return isIP;
    }

    calculateMinMaxIP = (ip) => {
        const BIGGEST_VALUE = 99254740736;
        const MEDIUM_VALUE = 65536;
        const MIN_VALUE = 256;
        const amountIP = [];
        let totalStart = 0;

        amountIP.push(ip[0] * BIGGEST_VALUE);
        amountIP.push(ip[1] * MEDIUM_VALUE);
        amountIP.push(ip[2] * MIN_VALUE);
        amountIP.push(ip[3]);

        totalStart = amountIP[0] + amountIP[1] + amountIP[2] + amountIP[3];

        return totalStart;
    }

    checkIPISValid = (IPText) => {
        let validIP = false;
        if (IPText) {
            const ipParts = IPText.split(".");
            if (ipParts.length === 4) {
                for (var i = 0; i < 4; i++) {
                    var theNum = parseInt(ipParts[i], 10);
                    if (theNum < 0 && theNum > 255) {
                        break;
                    }
                }
                if (i === 4) {
                    validIP = true;
                }
            }
        }
        return validIP;
    }
}

App.Routers.IPRangeProfile = IPRangeProfileRouter;
